<template>
    <!-- 1. Pantalla de bienvenida -->
    <div v-if="!sessionActive" class="fullscreen-prompt">
        <b-card title="Modo Pantalla Completa" class="text-center">
            <b-card-text>
                Haga clic en el botón para iniciar la visualización en pantalla completa.
            </b-card-text>
            <b-button variant="primary" size="lg" @click="startSession">
                <b-icon icon="display-fill" class="mr-2"></b-icon> Mostrar Pantalla Completa
            </b-button>
        </b-card>
    </div>

    <!-- 2. Loader principal (simplificado) -->
    <div v-else-if="loader" class="fullscreen-loader">
        <b-spinner style="width: 3rem; height: 3rem;" label="Cargando..."></b-spinner>
    </div>

    <!-- 3. Contenido principal -->
    <div v-else class="fullscreen-container">
        <div class="top-actions d-flex justify-content-center align-items-center my-1 px-3">
            <b-button size="sm" variant="outline-secondary" class="me-2 action-btn" @click="imprimir" title="Imprimir">
                <b-icon icon="printer" aria-hidden="true"></b-icon>
                <span class="d-none d-sm-inline ms-1">Imprimir</span>
            </b-button>
            <b-button size="sm" variant="outline-secondary" class="me-2 action-btn" @click="exitFullscreenAndClose" title="Cerrar Pantalla Completa">
                <b-icon icon="x-lg" aria-hidden="true"></b-icon>
                <span class="d-none d-sm-inline ms-1">Cerrar</span>
            </b-button>
        </div>
        <div class="row dashboard-container">
            <!-- Sección de Tarjetas KPI -->
            <div class="col-12 mb-3">
                <!-- Primera fila: 5 Tarjetas KPI -->
                <div class="row kpi-cards-section mb-3">
                    <div class="col-xl col-lg col-md-6 col-sm-6 col-12 mb-3">
                        <Tarjetas color="#D0F0AD" icono="hdd" titulo="Unidades instaladas" :data="unidades_activas" colorFont="#183E0C" :grafico="false" url="enlazadas" />
                    </div>
                    
                    <div class="col-xl col-lg col-md-6 col-sm-6 col-12 mb-3">
                        <Tarjetas color="#63A6D3" icono="list-check" titulo="Unidades sin alertas" :data="unidadesSinAlertas" colorFont="#16417C" :grafico="false" />
                    </div>

                    <div class="col-xl col-lg col-md-6 col-sm-6 col-12 mb-3">
                        <Tarjetas color="#FFD69D" icono="exclamation-triangle" titulo="Unidades alertadas" :data="alertas_historial_operaciones" colorFont="#D17A35" :grafico="false" url="con_alertas" />
                    </div>

                    <div class="col-xl col-lg col-md-6 col-sm-6 col-12 mb-3">
                        <Tarjetas color="#F3D1D0" icono="clock" titulo="Unidades que requieren mantenimiento" :data="unidades_proximas_mantenimiento" colorFont="#3A0603" :grafico="false" url="requiren_mantenimiento" />
                    </div>

                    <div class="col-xl col-lg col-md-12 col-sm-12 col-12 mb-3">
                        <Tarjetas color="#E7E5E4" icono="lightning" titulo="Consumo energético instantáneo" :data="energiaConsumidaHoy + ' kW'" colorFont="#000000" :grafico="false" />
                    </div>
                </div>

                <!-- Segunda fila: 4 Gráficos -->
                <div class="row charts-section">
                    <!-- Gráfico de línea - 30% del ancho -->
                    <div class="col-xl-3 col-lg-4 col-md-6 col-sm-12 col-12 mb-3">
                        <div class="chart-container chart-line">
                            <ConsumoHora :lecturas="lecturasConsumo" />
                        </div>
                    </div>
                    
                    <!-- Gráfico de barras - 30% del ancho -->
                    <div class="col-xl-3 col-lg-4 col-md-6 col-sm-12 col-12 mb-3">
                        <div class="chart-container chart-bar">
                            <Grafico />
                        </div>
                    </div>
                    
                    <!-- Gráfico de torta 1 - 20% del ancho -->
                    <div class="col-xl-3 col-lg-2 col-md-6 col-sm-12 col-12 mb-3">
                        <div class="chart-container chart-pie">
                            <TarjetaPie color="#FFFFFF" icono="hdd" titulo="Estado de las unidades" :data="datos" colorFont="#183E0C" v-if="showGraficos" />
                            <div v-else class="spinner-wrap"><b-spinner label="Cargando..." variant="primary" style="width: 2rem; height: 2rem;"></b-spinner></div>
                        </div>
                    </div>
                    
                    <!-- Gráfico de torta 2 - 20% del ancho -->
                    <div class="col-xl-3 col-lg-2 col-md-6 col-sm-12 col-12 mb-3">
                        <div class="chart-container chart-pie">
                            <TarjetaPie color="#FFFFFF" icono="gear" titulo="Tipos de unidades" :data="datosTiposUnidad" colorFont="#183E0C" v-if="showGraficosTiposUnidad" />
                            <div v-else class="spinner-wrap"><b-spinner label="Cargando..." variant="primary" style="width: 2rem; height: 2rem;"></b-spinner></div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Sección de Tabla - Ancho completo -->
            <div class="col-12 tabla-section">
                <!-- Header Section -->
                <div class="alerts-table-header">
                    <div class="header-content">
                        <div class="header-left">
                            <div class="header-icon">
                                <b-icon icon="exclamation-triangle-fill" font-scale="2"></b-icon>
                            </div>
                            <div class="header-text">
                                <h1 class="page-title">Unidades con alertas</h1>
                                <p class="page-subtitle">Monitoreo de equipos con alertas activas</p>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Main Content -->
                <div class="alerts-content-card">
                    <!-- Loading State -->
                    <div v-if="cargandoTabla" class="loading-container">
                        <div class="loading-content">
                            <b-spinner variant="primary" class="loading-spinner"></b-spinner>
                            <p class="loading-text">Cargando unidades con alertas...</p>
                        </div>
                    </div>

                    <!-- Alerts Table -->
                    <div v-else class="table-container" :key="`tabla-container-${paginaActual}-${unidadesConAlertas.length}-${tablaRenderKey}`">
                        <div class="custom-table">
                            <div class="table-header">
                                <div class="table-row header-row">
                                    <div class="table-cell">#</div>
                                    <div class="table-cell">Ubicación</div>
                                    <div class="table-cell">CBI</div>
                                    <div class="table-cell">Capacidad</div>
                                    <div class="table-cell header-icon-cell">
                                        <b-icon icon="exclamation-triangle" font-scale="1.5"></b-icon>
                                    </div>
                                    <div class="table-cell header-icon-cell">
                                        <b-icon icon="clock" font-scale="1.5"></b-icon>
                                    </div>
                                    <div class="table-cell">Total Alertas</div>
                                </div>
                            </div>
                            <div class="table-body">
                                <div v-for="(unidad, index) in unidadesConAlertas" 
                                     :key="unidad.id" 
                                     class="table-row data-row">
                                    <div class="table-cell" data-label="#">
                                        {{ index + 1 + (paginaActual - 1) * 5 }}
                                    </div>
                                    <div class="table-cell" data-label="Ubicación:">
                                        <div class="unit-info">
                                            <div class="unit-icon">
                                                <b-icon icon="thermometer-half" font-scale="1.8"></b-icon>
                                            </div>
                                            <router-link 
                                                :to="`/ver-unidad/${unidad.id}`" 
                                                class="unit-link"
                                            >
                                                {{ (unidad.ubicacion || '').toLowerCase() }}
                                            </router-link>
                                        </div>
                                    </div>
                                    <div class="table-cell" data-label="CBI:">
                                        <span class="cbi-badge">{{ unidad.cbi || 'N/A' }}</span>
                                    </div>
                                    <div class="table-cell" data-label="Capacidad:">
                                        <span class="capacity-badge">{{ formatCapacidad(unidad.capacidad) }}</span>
                                    </div>
                                    <div class="table-cell" data-label="Total Alertas:">
                                        <span class="total-alertas-badge">{{ unidad.total_alertas }}</span>
                                    </div>
                                    <div class="table-cell" data-label="Total Mantenimiento:">
                                        <span class="total-mantenimiento-badge">{{ unidad.total_alerta_actividades }}</span>
                                    </div>
                                    <div class="table-cell" data-label="# Alertas:">
                                        <span class="alerts-count-badge">{{ unidad.total_alertas_general || 0 }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Pagination -->
                        <div class="pagination-container" v-if="TotalUnidadesConAlertas > 5">
                            <b-pagination
                                v-model="paginaActual"
                                :total-rows="TotalUnidadesConAlertas"
                                :per-page="5"
                                class="custom-pagination"
                                size="sm"
                            ></b-pagination>
                        </div>
                    </div>
                </div>
            </div>
        </div>   
    </div>
</template>

<script>
import Tarjetas from '@/components/Graficos/Tarjeta.vue';
import TarjetaPie from '@/components/Graficos/TarjetaPie.vue';
import ConsumoHora from '@/components/Graficos/ConsumoHora.vue';
import axios from 'axios';
import Grafico from '@/components/Graficos/Grafico.vue';
// ✅ 1. Importar el helper de popups
import { iniciarPopupAlertas } from '@/helpers/popup.js';

export default {
    name: 'FullScreen',
    components: { Tarjetas, TarjetaPie, Grafico, ConsumoHora },
    data() {
        return {
            sessionActive: false,
            loader: false,
            periodicIntervalId: null,
            periodicIntervalMs: 5 * 60 * 1000, // 5 minutos
            alertas_historial_operaciones: 0,
            datos: { labels: [], data: [], backgroundColor: [], borderColor: [] },
            datosTiposUnidad: { labels: [], data: [], backgroundColor: [], borderColor: [] },
            lecturasConsumo: [],
            fields: [
                { key: 'index', label: '#' },
                { key: 'ubicacion', label: 'Ubicación' },
                { key: 'cbi', label: 'CBI' },
                { key: 'capacidad', label: 'Capacidad' },
                { key: 'estado_equipo', label: 'ON/OFF' },
                { key: 'total_alertas', label: '# Alertas' },
                { key: 'fecha', label: 'Fecha' },
            ],
            unidadesConAlertas: [],
            paginaActual: 1,
            TotalUnidadesConAlertas: 0,
            unidadesSinAlertas: 0,
            unidades_activas: 0,
            unidades_inactivas: 0,
            unidades_proximas_mantenimiento: 0,
            showGraficos: false,
            showGraficosTiposUnidad: false,
            reporte: {tipo: 1, fecha_inicial: null, fecha_final: null},
            isFullscreen: false,
            lecturasPorTipoReporte: [],
            newWindow: null,
            _newWindowInterval: null,
            tituloAlerta: null,
            periodicRunning: false,
            requestCooldownUntil: 0,
            cooldownMsOn429: 5 * 60 * 1000,
            
            // control de ventana master
            isMasterWindow: false,
            windowId: null,
            
            // control periódico
            componenteMontadoPorPrimeraVez: false,
            primeraCargaCompletada: false,
            
            // keys para forzar remount de componentes
            cargandoTabla: false,
            tablaRenderKey: 0,
            
            cargandoInicial: true,
            energiaConsumidaHoy: 0,
            
            // Intervalo para cálculo de energía (5 minutos)
            energiaIntervalId: null,
            energiaIntervalMs: 5 * 60 * 1000, // 5 minutos
        };
    },

    computed: {
        energiaFormateada() {
            if (!this.energiaConsumidaHoy) return '0';
            const numero = parseFloat(this.energiaConsumidaHoy);
            
            // Si el número es mayor o igual a 1000, mostrar en formato K
            if (numero >= 1000) {
                const valorK = Math.round(numero / 1000);
                return `${valorK.toLocaleString('es-CO')} K`;
            }
            
            // Si es menor a 1000, mostrar normal sin decimales
            return `${Math.round(numero).toLocaleString('es-CO')}`;
        }
    },

    mounted() {
        document.addEventListener('fullscreenchange', this.onFullscreenChange);
    },
    beforeDestroy() {
        console.log('🛑 FullScreen destruido.');
        this.stopPeriodicTasks();
        this.stopEnergiaTask();
        this.exitFullscreen();
        document.removeEventListener('fullscreenchange', this.onFullscreenChange);
    },
    watch: {
        paginaActual: {
            async handler(newPage, oldPage) {
                if (this.cargandoInicial) return;
                if (newPage && newPage !== oldPage) {
                    await this.cargarUnidadesConAlertas();
                }
            },
        }
    },
    methods: {
        async startSession() {
            this.sessionActive = true;
            this.loader = true;
            
            await this.requestFullscreen();
            this.cargandoInicial = true;
            
            try {
                await Promise.all([
                    this.cargarDatosDashboard(),
                    this.cargarUnidadesConAlertas()
                ]);
                // ✅ 2. Iniciar el sistema de popups después de la carga inicial
                this.comprobarToast();
            } catch (error) {
                console.error("Error al cargar datos iniciales en startSession:", error);
            }

            this.startPeriodicTasks();
            this.startEnergiaTask();
            this.cargandoInicial = false;
            this.loader = false;
        },
        // ✅ 3. Añadir el método para iniciar los popups
        comprobarToast() {
            const controlador = iniciarPopupAlertas(this.$store);
            controlador.start();
        },
        imprimir() { window.print(); },
        async requestFullscreen() {
            try {
                if (document.documentElement.requestFullscreen) {
                    await document.documentElement.requestFullscreen();
                }
            } catch (e) {
                console.warn('No se pudo activar la pantalla completa:', e);
            }
        },
        async exitFullscreen() {
            try {
                if (document.fullscreenElement && document.exitFullscreen) {
                    await document.exitFullscreen();
                }
            } catch (e) {
                console.warn('No se pudo salir de la pantalla completa:', e);
            }
        },
        async exitFullscreenAndClose() {
            await this.exitFullscreen();
            window.close();
        },
        onFullscreenChange() {
            if (!document.fullscreenElement) {
                window.close();
            }
        },
        async safeGet(url, opts = {}) {
            const now = Date.now();
            if (this.requestCooldownUntil > now) {
                console.warn('[FullScreen][safeGet] en cooldown, omitiendo petición a', url);
                throw { code: 'COOLDOWN' };
            }
            try {
                return await axios.get(url, { ...opts, headers: { ...(opts.headers||{}), Authorization: `Bearer ${this.$store.state.user?.token || ''}` } });
            } catch (err) {
                if (err?.response?.status === 429) {
                    this.requestCooldownUntil = Date.now() + this.cooldownMsOn429;
                    console.warn(`⚠️ [FullScreen][safeGet] 429 recibido, activando cooldown por ${this.cooldownMsOn429/1000} segundos (${this.cooldownMsOn429/60000} minutos) para`, url);
                }
                throw err;
            }
        },
        async safePost(url, data = {}, opts = {}) {
            const now = Date.now();
            if (this.requestCooldownUntil > now) {
                console.warn('[FullScreen][safePost] en cooldown, omitiendo petición a', url);
                throw { code: 'COOLDOWN' };
            }
            try {
                return await axios.post(url, data, { ...opts, headers: { ...(opts.headers||{}), Authorization: `Bearer ${this.$store.state.user?.token || ''}` } });
            } catch (err) {
                if (err?.response?.status === 429) {
                    this.requestCooldownUntil = Date.now() + this.cooldownMsOn429;
                    console.warn(`⚠️ [FullScreen][safePost] 429 recibido, activando cooldown por ${this.cooldownMsOn429/1000} segundos (${this.cooldownMsOn429/60000} minutos) para`, url);
                }
                throw err;
            }
        },
        startPeriodicTasks() {
            this.stopPeriodicTasks();
            console.log(`🚀 [FullScreen] Iniciando tareas periódicas (Intervalo: ${this.periodicIntervalMs}ms = ${this.periodicIntervalMs/60000} minutos)`);
            console.log(`⏰ [FullScreen] Próxima ejecución automática en ${this.periodicIntervalMs/60000} minutos`);
            this.periodicIntervalId = setInterval(this.runAllPeriodic, this.periodicIntervalMs);
        },
        stopPeriodicTasks() {
            if (this.periodicIntervalId) {
                clearInterval(this.periodicIntervalId);
                this.periodicIntervalId = null;
                console.log('🚫 [FullScreen] Tareas periódicas detenidas.');
            }
        },

        // Funciones para manejar el intervalo de energía (5 minutos)
        startEnergiaTask() {
            this.stopEnergiaTask();
            console.log(`🔋 [FullScreen] Iniciando tarea de energía (Intervalo: ${this.energiaIntervalMs}ms = ${this.energiaIntervalMs/60000} minutos)`);
            console.log(`⏰ [FullScreen] Próximo cálculo de energía en ${this.energiaIntervalMs/60000} minutos`);
            this.energiaIntervalId = setInterval(this.calcularTotalEnergiaAhora, this.energiaIntervalMs);
        },

        stopEnergiaTask() {
            if (this.energiaIntervalId) {
                clearInterval(this.energiaIntervalId);
                this.energiaIntervalId = null;
                console.log('🚫 [FullScreen] Tarea de energía detenida.');
            }
        },
        async runAllPeriodic() {
            if (this.periodicRunning) {
                console.warn('[FullScreen] runAllPeriodic ya está en ejecución, saltando...');
                return;
            }
            
            if (Date.now() < this.requestCooldownUntil) {
                console.warn('[FullScreen] Saltando ejecución por cooldown hasta', new Date(this.requestCooldownUntil).toLocaleString('es-CO'));
                return;
            }

            console.log('🔄 [FullScreen] Ejecutando tareas periódicas automáticas...');
            this.periodicRunning = true;
            try {
                const funcs = [
                    'count_unidades',
                    'count_unidades_proximas_mantenimiento',
                    'count_unidades_sin_alertas_activas',
                    'count_alertas_historial_operaciones',
                    'consultarLecturasPorTipoReporte',
                    'count_unidades_on_off',
                    'count_tipos_unidades',
                ];

                for (const fn of funcs) {
                    if (typeof this[fn] === 'function') {
                        try {
                            const res = this[fn]();
                            if (res && typeof res.then === 'function') {
                                await res;
                            }
                        } catch (errFn) {
                            if (errFn && errFn.code === 'COOLDOWN') {
                                console.warn('[FullScreen] peticiones bloqueadas por cooldown, deteniendo la tanda');
                                break;
                            }
                            console.error(`[FullScreen] Error ejecutando ${fn}:`, errFn);
                        }
                    }
                }
                
                // Añadir la comprobación de popups a las tareas periódicas
                this.comprobarToast();
                
                console.log('✅ [FullScreen] Tareas periódicas completadas');
                
            } finally {
                this.periodicRunning = false;
            }
        },
        async cargarDatosDashboard() {
            console.log('📊 [FullScreen] Cargando datos INICIALES del dashboard (tarjetas y gráficos)...');
            try {
                await Promise.all([
                    this.count_unidades(),
                    this.count_unidades_proximas_mantenimiento(),
                    this.count_unidades_sin_alertas_activas(),
                    this.count_alertas_historial_operaciones(),
                    this.consultarLecturasPorTipoReporte(),
                    this.count_unidades_on_off(),
                    this.count_tipos_unidades(),
                    // ✅ 3. CAMBIO: Añadir el cálculo de energía a la carga
                    this.calcularTotalEnergiaAhora()
                ]);
                console.log('✅ [FullScreen] Datos INICIALES del dashboard cargados.');
            } catch (err) {
                console.error('❌ [FullScreen] Error durante la carga de datos del dashboard:', err);
            }
        },
        // ✅ 5. Reemplazar con la lógica de carga de tabla robusta de Inicio.vue
        async cargarUnidadesConAlertas() {
            try {
                console.log('📋 [FullScreen] Cargando tabla, página:', this.paginaActual);
                const url = `/api/unidades-con-alertas?page=${this.paginaActual}&per_page=5`;
                const response = await this.safeGet(url);

                let datos = null;
                let total = 0;

                if (response.data.unidades && response.data.unidades.data && Array.isArray(response.data.unidades.data)) {
                    datos = response.data.unidades.data;
                    total = response.data.unidades.total || response.data.total || 0;
                } else if (response.data.data && Array.isArray(response.data.data)) {
                    datos = response.data.data;
                    total = response.data.total || 0;
                } else if (response.data.unidades && Array.isArray(response.data.unidades)) {
                    datos = response.data.unidades;
                    total = response.data.total || datos.length;
                } else if (Array.isArray(response.data)) {
                    datos = response.data;
                    total = response.data.length;
                } else {
                    datos = [];
                    total = 0;
                }

                this.unidadesConAlertas = datos || [];
                this.TotalUnidadesConAlertas = total;
                
                console.log('✅ [FullScreen] Tabla cargada:', {
                    registros: this.unidadesConAlertas.length,
                    total: this.TotalUnidadesConAlertas,
                    pagina: this.paginaActual
                });

            } catch (err) {
                if (err && err.code === 'COOLDOWN') return;
                console.error('[FullScreen] Error cargando unidades con alertas:', err);
                this.unidadesConAlertas = [];
                this.TotalUnidadesConAlertas = 0;
            }
        },
        // ✅ 4. CAMBIO: Añadir la función para calcular energía (copiada de Inicio.vue)
        calcularEnergiaConsumida(lectura) {
            if (!lectura) return 0;
            let potencia = 0;
            if (typeof lectura.tiporede_id !== 'undefined') {
                if (lectura.tiporede_id === 1) potencia = Number(lectura.potencia_interior || 0);
                else if (lectura.tiporede_id === 2) potencia = Number(lectura.potencia_exterior || 0) + Number(lectura.potencia_interior || 0);
                else potencia = (3 * Number(lectura.potencia_exterior || 0) * Number(lectura.fp_exterior || 0)) + Number(lectura.potencia_interior || 0);
                const tiempoOn = Number(lectura.tiempo_on || 0);
                return (String(lectura.estado).toUpperCase() === 'ON') ? (potencia * (tiempoOn / 3600)) : 0;
            }
            return Number(lectura.valor ?? lectura.valor_kwh ?? lectura.kwh ?? lectura.energy ?? lectura.value ?? 0) || 0;
        },
        async calcularTotalEnergiaAhora() {
            try {
                const response = await this.safeGet('/api/lecturas-now');
                const lecturas = response.data.lecturas || response.data || [];
                
                if (Array.isArray(lecturas)) {
                    // Nuevo cálculo según especificaciones
                    const totalPotencia = lecturas.reduce((acumulador, lectura) => {
                        let potencia = 0;
                        
                        if (lectura.tiporede_id === 1) {
                            // Solo potencia interior
                            potencia = Number(lectura.potencia_interior || 0);
                        } else {
                            // Potencia interior + potencia exterior
                            potencia = Number(lectura.potencia_interior || 0) + Number(lectura.potencia_exterior || 0);
                        }
                        
                        return acumulador + potencia;
                    }, 0);

                    // Asignamos el valor acumulado sin dividir entre 1000
                    this.energiaConsumidaHoy = (totalPotencia/1000).toFixed(2);
                }
            } catch (error) {
                if (error && error.code === 'COOLDOWN') return;
                console.error('Error calculando la energía total de hoy:', error);
                this.energiaConsumidaHoy = 0;
            }
        },
        async consultarLecturasPorTipoReporte() {
            // ahora solo guardamos las lecturas crudas para que ConsumoHora las procese
            try {
                const params = { tipo_reporte: this.reporte.tipo };
                if (this.reporte.tipo === 5) {
                    params.fecha_inicial = this.reporte.fecha_inicial;
                    params.fecha_final = this.reporte.fecha_final;
                }
                const response = await this.safePost('/api/lecturas-por-tipo-reporte', params);
                const rows = response.data.lecturas ?? response.data ?? [];
                this.lecturasConsumo = Array.isArray(rows) ? rows : [];
            } catch (error) {
                if (error && error.code === 'COOLDOWN') return;
                console.error('Error consultando lecturas por tipo de reporte:', error);
                this.lecturasConsumo = [];
            }
        },
        async count_alertas_historial_operaciones() {
            try {
                const response = await this.safeGet('/api/count-alertas-historial-operaciones');
                this.alertas_historial_operaciones = response.data.total ?? 0;
            } catch (error) { if (error.code !== 'COOLDOWN') this.alertas_historial_operaciones = 0; }
        },
        async count_unidades_sin_alertas_activas() {
            try {
                const response = await this.safeGet('/api/count-unidades-sin-alertas-activas');
                this.unidadesSinAlertas = response.data.total ?? 0;
            } catch (error) { if (error.code !== 'COOLDOWN') this.unidadesSinAlertas = 0; }
        },
        async count_unidades() {
            try {
                const response = await this.safeGet('/api/count-unidades-activas');
                this.unidades_activas = response.data.total_unidades_activas ?? 0;
            } catch (error) { if (error.code !== 'COOLDOWN') console.error('Error count_unidades:', error); }
        },
        async count_unidades_on_off() {
            this.showGraficos = false;
            try {
                const response = await this.safeGet('/api/count-unidades-on-off');
                this.datos = {
                    labels: ['ON', 'OFF', 'Desconectado'],
                    data: [response.data.ON ?? 0, response.data.OFF ?? 0, response.data.Desconectado ?? 0],
                    backgroundColor: ['#2ECC71', '#E7E5E4', '#4D4A4A'],
                    borderColor: ['#2ECC71', '#E7E5E4', '#4D4A4A'],
                };
            } catch (error) {
                if (error.code !== 'COOLDOWN') console.error('Error en count_unidades_on_off:', error);
                this.datos = { labels: ['ON', 'OFF', 'Desconectado'], data: [0, 0, 0], backgroundColor: ['#2ECC71', '#E7E5E4', '#4D4A4A'], borderColor: ['#2ECC71', '#E7E5E4', '#4D4A4A'] };
            } finally {
                this.showGraficos = true;
            }
        },
        async count_tipos_unidades() {
            this.showGraficosTiposUnidad = false;
            try {
                const response = await this.safeGet('/api/tipos-unidades');
                this.datosTiposUnidad = {
                    labels: response.data.tipos?.map(item => item.tipo_equipo) ?? [],
                    data: response.data.tipos?.map(item => item.total_unidades) ?? [],
                    backgroundColor: ['#FF6384', '#36A2EB', '#FFCE56', '#4BC0C0', '#9966FF', '#FF9F40'],
                    borderColor: ['#FF6384', '#36A2EB', '#FFCE56', '#4BC0C0', '#9966FF', '#FF9F40'],
                };
            } catch (error) {
                if (error.code !== 'COOLDOWN') console.error('Error en count_tipos_unidades:', error);
                this.datosTiposUnidad = { labels: [], data: [], backgroundColor: [], borderColor: [] };
            } finally {
                this.showGraficosTiposUnidad = true;
            }
        },
        async count_unidades_proximas_mantenimiento() {
            try {
                const response = await this.safeGet('/api/count-alerta-actividades');
                this.unidades_proximas_mantenimiento = response.data.total ?? 0;
            } catch (error) { if (error.code !== 'COOLDOWN') this.unidades_proximas_mantenimiento = 0; }
        },
        formatFecha(fecha) {
            if (!fecha) return '';
            return new Date(fecha).toLocaleDateString('es-CO', { year: 'numeric', month: '2-digit', day: '2-digit' });
        },

        toggleMapa() {
            this.$router.push({ name: 'InicioConMapa' });
        },

        async toggleFullscreen() {
            try {
                if (this.newWindow && !this.newWindow.closed) {
                    this.closeNewWindow();
                } else {
                    this.openInNewWindow();
                }
            } catch (e) {
                console.error('Error toggling new window', e);
            }
        },

        async openInNewWindow() {
            // crear id para la nueva ventana (opcional, útil para debugging)
            const newWinId = `${Date.now()}_${Math.floor(Math.random()*10000)}`;
            // resolver ruta /inicio-fullscreen con query slave=1 para indicar modo "slave"
            const route = this.$router.resolve({ name: 'Inicio-Fullscreen', query: { slave: '1', windowId: newWinId } });
            const url = window.location.origin + route.href;

            // abrir nueva ventana apuntando a la ruta de la app (cargará SPA y la vista fullscreen en modo slave)
            this.newWindow = window.open(url, '_blank', 'noopener,noreferrer,width=1400,height=900');

            if (!this.newWindow) {
                console.warn('No se pudo abrir la nueva ventana (popup bloqueado)');
                return;
            }

            this.isFullscreen = !!(this.newWindow && !this.newWindow.closed);

            // monitor de cierre
            if (this._newWindowInterval) clearInterval(this._newWindowInterval);
            this._newWindowInterval = setInterval(() => {
                if (!this.newWindow || this.newWindow.closed) {
                    clearInterval(this._newWindowInterval);
                    this._newWindowInterval = null;
                    this.newWindow = null;
                    this.isFullscreen = false;
                }
            }, 500);
        },

        closeNewWindow() {
            try {
                if (this.newWindow && !this.newWindow.closed) this.newWindow.close();
            } catch (e) { /* silent */ }
            if (this._newWindowInterval) {
                clearInterval(this._newWindowInterval);
                this._newWindowInterval = null;
            }
            this.newWindow = null;
            this.isFullscreen = false;
        },

        formatCapacidad(capacidad) {
            if (!capacidad || capacidad === 0) return '';
            // Convertir a número y formatear con separador de miles
            const numero = Number(capacidad);
            if (isNaN(numero)) return capacidad;
            return numero.toLocaleString('es-CO') + ' BTU';
        },
    }
};
</script>

<style scoped>
/* Fullscreen specific styles */
.fullscreen-prompt {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100vw;
    height: 100vh;
    background-color: #f8f9fa;
}
html, body {
    overflow: hidden !important;
}
.fullscreen-container {
    background-color: white;
    width: 100vw;
    height: 100vh;
    overflow-y: auto;
    padding: 1rem;
}
.fullscreen-loader {
    width: 100vw;
    height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
}
@media print {
    .top-actions { display: none !important; }
    .dashboard-container { padding: 0 !important; }
}

/* ✅ Se añade ::v-deep para que los estilos afecten a los componentes hijos */

/* Estilos modernos para la tabla de unidades con alertas */
/* Header Section */
.alerts-table-header {
    background: white;
    border-radius: 20px;
    padding: 1.5rem 2rem;
    margin-bottom: 1.5rem;
    margin-top: 1rem;
    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.1);
    border: 1px solid rgba(255, 255, 255, 0.2);
}

.alerts-table-header .header-content {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.alerts-table-header .header-left {
    display: flex;
    align-items: center;
    gap: 1.5rem;
}

.alerts-table-header .header-icon {
    width: 80px;
    height: 80px;
    background: linear-gradient(135deg, #dc3545 0%, #c82333 100%);
    border-radius: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
    box-shadow: 0 8px 20px rgba(220, 53, 69, 0.3);
}

.alerts-table-header .page-title {
    font-size: 2.5rem;
    font-weight: 700;
    color: #1a2732;
    margin: 0;
    text-shadow: 2px 2px 4px rgba(26, 39, 50, 0.3);
}

.alerts-table-header .page-subtitle {
    color: #718096;
    font-size: 1.1rem;
    margin: 0.5rem 0 0 0;
    font-weight: 400;
}

/* Content Card */
.alerts-content-card {
    background: white;
    border-radius: 20px;
    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.1);
    overflow: hidden;
    border: 1px solid rgba(255, 255, 255, 0.2);
}

/* Loading */
.alerts-content-card .loading-container {
    padding: 4rem;
    text-align: center;
}

.alerts-content-card .loading-content {
    display: inline-flex;
    flex-direction: column;
    align-items: center;
    gap: 1rem;
}

.alerts-content-card .loading-spinner {
    width: 3rem;
    height: 3rem;
}

.alerts-content-card .loading-text {
    color: #718096;
    font-size: 1.1rem;
    margin: 0;
}

/* Custom Table */
.alerts-content-card .table-container {
    padding: 1.5rem 2rem 2rem 2rem;
}

.alerts-content-card .custom-table {
    width: 100%;
    border-radius: 15px;
    overflow: hidden;
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.05);
}

.alerts-content-card .table-header {
    background: linear-gradient(135deg, #1a2732 0%, #2a3f4f 100%);
}

.alerts-content-card .header-row {
    color: white;
    font-weight: 600;
    font-size: 0.9rem;
    text-transform: uppercase;
    letter-spacing: 0.5px;
}

.alerts-content-card .table-row {
    display: grid;
    grid-template-columns: 60px 2fr 150px 130px 100px 100px 120px;
    gap: 0.75rem;
    align-items: center;
}

.alerts-content-card .data-row {
    background: white;
    border-bottom: 1px solid #e2e8f0;
    transition: all 0.3s ease;
}

.alerts-content-card .data-row:hover {
    background: #f7fafc;
    transform: translateX(5px);
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
}

.alerts-content-card .table-cell {
    padding: 0.75rem 0.5rem;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 0.9rem;
    text-align: center;
}

/* Excepción para la celda de ubicación que necesita alineación a la izquierda */
.alerts-content-card .table-cell:nth-child(2) {
    justify-content: flex-start;
    text-align: left;
}

/* Centrado específico para la primera columna (número de fila) */
.alerts-content-card .table-cell:nth-child(1) {
    justify-content: center;
    text-align: center;
    font-weight: 600;
    color: #718096;
}

/* Asegurar centrado para las columnas de badges */
.alerts-content-card .table-cell:nth-child(3),
.alerts-content-card .table-cell:nth-child(4),
.alerts-content-card .table-cell:nth-child(5),
.alerts-content-card .table-cell:nth-child(6),
.alerts-content-card .table-cell:nth-child(7) {
    justify-content: center;
    text-align: center;
}

.alerts-content-card .unit-info {
    display: flex;
    align-items: center;
    gap: 0.75rem;
}

.alerts-content-card .unit-icon {
    color: #dc3545;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    border-radius: 8px;
    background: rgba(220, 53, 69, 0.1);
    transition: all 0.3s ease;
}

.alerts-content-card .unit-icon:hover {
    background: rgba(220, 53, 69, 0.2);
    transform: scale(1.05);
}

.alerts-content-card .header-icon-cell {
    justify-content: center !important;
    text-align: center;
}

.alerts-content-card .header-icon-cell .b-icon {
    color: rgba(255, 255, 255, 0.9);
    transition: all 0.3s ease;
}

.alerts-content-card .header-icon-cell:hover .b-icon {
    color: white;
    transform: scale(1.1);
}

.alerts-content-card .unit-link {
    font-weight: 600;
    color: #1a2732;
    text-decoration: none;
    text-transform: capitalize;
    transition: color 0.3s ease;
}

.alerts-content-card .unit-link:hover {
    color: #dc3545;
    text-decoration: none;
}

.alerts-content-card .cbi-badge {
    background: linear-gradient(135deg, #ddd6fe 0%, #c4b5fd 100%);
    color: #5b21b6;
    padding: 0.3rem 0.6rem;
    border-radius: 15px;
    font-size: 0.8rem;
    font-weight: 600;
    border: 1px solid #a78bfa;
    font-family: 'Courier New', monospace;
}

.alerts-content-card .capacity-badge {
    background: linear-gradient(135deg, #e2e8f0 0%, #cbd5e0 100%);
    color: #1a2732;
    padding: 0.3rem 0.6rem;
    border-radius: 15px;
    font-size: 0.8rem;
    font-weight: 600;
    border: 1px solid #a0aec0;
}

.alerts-content-card .alerts-count-badge {
    background: linear-gradient(135deg, #fecaca 0%, #fca5a5 100%);
    color: #991b1b;
    padding: 0.3rem 0.6rem;
    border-radius: 15px;
    font-size: 0.8rem;
    font-weight: 700;
    border: 1px solid #f87171;
    min-width: 35px;
    text-align: center;
    font-family: 'Courier New', monospace;
}

.alerts-content-card .total-alertas-badge {
    background: linear-gradient(135deg, #D17A35 0%, #b86b2d 100%);
    color: white;
    padding: 0.3rem 0.6rem;
    border-radius: 15px;
    font-size: 0.8rem;
    font-weight: 700;
    border: 1px solid #c16c31;
    min-width: 35px;
    text-align: center;
    font-family: 'Courier New', monospace;
    box-shadow: 0 2px 4px rgba(209, 122, 53, 0.3);
}

.alerts-content-card .total-mantenimiento-badge {
    background: linear-gradient(135deg, #F3D1D0 0%, #e8bbb9 100%);
    color: #8b5a5a;
    padding: 0.3rem 0.6rem;
    border-radius: 15px;
    font-size: 0.8rem;
    font-weight: 700;
    border: 1px solid #d4a8a6;
    min-width: 35px;
    text-align: center;
    font-family: 'Courier New', monospace;
    box-shadow: 0 2px 4px rgba(243, 209, 208, 0.4);
}

.alerts-content-card .date-text {
    color: #718096;
    font-size: 0.8rem;
    font-weight: 500;
    text-align: center;
    font-family: 'Courier New', monospace;
}

/* Pagination */
.alerts-content-card .pagination-container {
    display: flex;
    justify-content: center;
    margin-top: 2rem;
}

.alerts-content-card .custom-pagination {
    border-radius: 15px;
    overflow: hidden;
}




/* El resto de los estilos no necesitan ::v-deep porque aplican a clases del componente actual */
.tarjetas-column {
    display: flex;
    flex-direction: column;
    gap: 1rem;
    align-items: stretch;
}

.chart-column {
    display: flex;
    flex-direction: column;
    gap: 1rem;
    align-items: stretch;
}

.Grafico-wrapper {
    width: 100%;
}

.tarjetas-column > * {
    margin: 0;
}

.card-placeholder {
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 120px;
    padding: 0.5rem;
    box-sizing: border-box;
}

.spinner-wrap {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
}

.tarjetas-row {
    display: flex;
    flex-wrap: nowrap;
    gap: 1rem;
    justify-content: space-between;
    align-items: stretch;
    margin-bottom: 1rem;
}

/* Responsive Design */
.dashboard-container {
    padding: 1rem;
}

.top-actions {
    margin-bottom: 0.5rem !important; /* Reducir espacio hacia las tarjetas */
}

.kpi-cards-section {
    margin-bottom: 1rem; /* Reducido de 1.5rem a 1rem */
}

.kpi-cards-section.row {
    flex-wrap: nowrap; /* Forzar que las tarjetas permanezcan en una línea */
    overflow-x: auto; /* Scroll horizontal si es necesario */
}

.kpi-cards-section > [class*="col-"] {
    flex: 0 0 auto; /* No permitir que las columnas se contraigan */
    min-width: 200px; /* Ancho mínimo para cada tarjeta */
}

.charts-section {
    margin-bottom: 0.5rem; /* Reducido aún más para ganar espacio */
    margin-top: 0.5rem; /* Reducir espacio superior */
}

.charts-section.row {
    margin-left: 0;
    margin-right: 0;
    width: 100%;
}

.tabla-section {
    margin-top: 0;
    padding-top: 0;
}



.chart-container {
    height: 350px;
    background: #fff;
    border-radius: 8px;
    padding: 0.75rem; /* Reducido de 1rem a 0.75rem */
    box-shadow: 0 2px 8px rgba(0,0,0,0.08);
    display: flex;
    align-items: stretch;
    justify-content: center;
    overflow: hidden;
}

.chart-line {
    /* Gráfico de línea - 30% del ancho */
    flex: 1;
}

.chart-bar {
    /* Gráfico de barras - 30% del ancho */
    flex: 1;
}

.chart-bar .Grafico-wrapper {
    height: 100%;
    display: flex;
    flex-direction: column;
}

.chart-bar .card {
    height: 100%;
    display: flex;
    flex-direction: column;
}

.chart-bar .card-body {
    flex: 1;
    display: flex;
    flex-direction: column;
}

.chart-pie {
    /* Gráficos de torta - 20% cada uno */
    flex: 0.67;
    display: flex;
    align-items: center;
    justify-content: center;
}

.chart-pie .card {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 0.5rem; /* Reducir padding de la card */
}

.chart-pie .card-body {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    padding: 0.75rem; /* Reducir padding del body */
}

/* Forzar centrado del canvas dentro del gráfico de torta */
.chart-pie canvas {
    margin: 0 auto !important;
    display: block !important;
}

.chart-pie .chart-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
}

/* Centrado específico para el componente Tarjeta dentro de chart-pie */
.chart-pie .tarjeta-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 100%;
    width: 100%;
}

.chart-pie .chart-container-pie {
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0 auto;
}

/* Forzar centrado absoluto para gráficos de torta */
.chart-pie .tarjeta-grafico {
    display: flex !important;
    justify-content: center !important;
    align-items: center !important;
    text-align: center !important;
}

.chart-pie .chart-pie-container {
    margin: 0 auto;
    text-align: center;
    width: 100%;
    overflow: hidden;
}

/* Asegurar que los gráficos de torta ocupen todo su espacio */
.chart-pie {
    width: 100% !important;
    overflow: hidden;
}

.chart-pie .tarjeta-grafico {
    width: 100% !important;
    margin: 0 !important;
}

/* Clases CSS específicas para proporciones exactas */
@media (min-width: 1200px) {
    /* Gráfico de línea y barras - 30% cada uno */
    .charts-section .col-xl-3:nth-child(1),
    .charts-section .col-xl-3:nth-child(2) {
        flex: 0 0 30%; /* 30% exacto */
        max-width: 30%;
    }
    
    /* Gráficos de torta - 20% cada uno */
    .charts-section .col-xl-3:nth-child(3),
    .charts-section .col-xl-3:nth-child(4) {
        flex: 0 0 20%; /* 20% exacto */
        max-width: 20%;
        padding-right: 0.75rem; /* Controlar padding derecho */
        padding-left: 0.75rem; /* Controlar padding izquierdo */
    }
    
    /* Eliminar padding extra del último elemento */
    .charts-section .col-xl-3:nth-child(4) {
        padding-right: 0; /* Sin padding derecho en el último */
    }
}

/* Desktop (XL) */
@media (min-width: 1200px) {
    .dashboard-container {
        padding: 2rem;
    }
    
    .kpi-cards-section > [class*="col-"] {
        flex: 1 1 0%; /* Distribuir equitativamente el espacio */
        min-width: 180px;
        max-width: none;
    }
}

/* Tablet Grande (LG) */
@media (max-width: 1199.98px) and (min-width: 992px) {
    .dashboard-container {
        padding: 1.5rem;
    }
    
    .tarjetas-column {
        gap: 0.8rem;
    }
    
    .kpi-cards-section > [class*="col-"] {
        flex: 1 1 0%; /* Distribuir equitativamente el espacio */
        min-width: 160px;
    }
    
    .charts-section .col-lg-5 {
        flex: 0 0 50%; /* En tablets, el gráfico de línea ocupa 50% */
        max-width: 50%;
    }
    
    .charts-section .col-lg-3,
    .charts-section .col-lg-4 {
        flex: 0 0 25%; /* Los gráficos de torta 25% cada uno */
        max-width: 25%;
    }
}

/* Tablet (MD) */
@media (max-width: 991.98px) and (min-width: 768px) {
    .dashboard-container {
        padding: 1rem;
    }
    
    .kpi-cards-section .col-md-6 {
        margin-bottom: 1rem;
    }
    
    .charts-section .col-md-6 {
        margin-bottom: 1rem;
    }
    
    .charts-section .col-md-12 {
        margin-bottom: 1rem;
    }
    
    .chart-container {
        height: 280px;
    }
}

/* Móvil Grande (SM) */
@media (max-width: 767.98px) and (min-width: 576px) {
    .dashboard-container {
        padding: 0.8rem;
    }
    
    .top-actions {
        flex-wrap: wrap;
        gap: 0.5rem;
        margin: 0.5rem 0; /* Reducir margen vertical */
    }
    
    .tarjetas-column {
        gap: 0.8rem;
    }
    
    .kpi-cards-section .col-sm-6 {
        margin-bottom: 1rem;
    }
    
    .charts-section .col-sm-12 {
        margin-bottom: 0.75rem;
    }
    
    .charts-section {
        margin-bottom: 0.25rem;
        margin-top: 0.25rem;
    }
    
    .tabla-section {
        margin-top: 0.25rem;
    }
    
    .tabla-unidadesConAlertas-card {
        margin-bottom: 1rem;
    }
    
    .chart-container {
        height: 250px;
    }
    
    .chart-pie {
        justify-content: center;
        align-items: center;
    }
}

/* Móvil Pequeño (XS) */
@media (max-width: 575.98px) {
    .dashboard-container {
        padding: 0.5rem;
    }
    
    .top-actions {
        flex-direction: column;
        gap: 0.5rem;
        margin: 0.25rem 0; /* Margen aún más reducido en móvil */
    }
    
    .top-actions .btn {
        width: 100%;
        max-width: 200px;
    }
    
    .tarjetas-column {
        gap: 0.8rem;
    }
    
    .kpi-cards-section .col-12 {
        margin-bottom: 1rem;
    }
    
    .charts-section .col-12 {
        margin-bottom: 0.75rem;
    }
    
    .charts-section {
        margin-bottom: 0.25rem;
        margin-top: 0.25rem;
    }
    
    .tabla-section {
        margin-top: 0.25rem;
    }
    
    .chart-container {
        height: 220px;
    }
    
    .chart-pie {
        justify-content: center;
        align-items: center;
    }
    
    /* Tabla de alertas responsiva en móvil */
    .alerts-table-header {
        padding: 1rem;
    }
    
    .alerts-table-header .header-content {
        flex-direction: column;
        gap: 1rem;
        text-align: center;
    }
    
    .alerts-table-header .page-title {
        font-size: 2rem;
    }
    
    .alerts-content-card .table-container {
        padding: 1rem;
    }
    
    .alerts-content-card .table-row {
        display: block;
        padding: 1rem;
        border-radius: 10px;
        margin-bottom: 1rem;
        box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    }
    
    .alerts-content-card .table-header {
        display: none;
    }
    
    .alerts-content-card .table-cell {
        display: block;
        padding: 0.5rem 0;
        border-bottom: 1px solid #eee;
        text-align: left;
        justify-content: flex-start;
    }
    
    /* En móvil, centrar solo el contenido de badges y números */
    .alerts-content-card .table-cell .cbi-badge,
    .alerts-content-card .table-cell .capacity-badge,
    .alerts-content-card .table-cell .total-alertas-badge,
    .alerts-content-card .table-cell .total-mantenimiento-badge,
    .alerts-content-card .table-cell .alerts-count-badge {
        display: inline-block;
        margin-left: 0.5rem;
    }
    
    .alerts-content-card .table-cell:last-child {
        border-bottom: none;
    }
    
    .alerts-content-card .table-cell:before {
        content: attr(data-label);
        font-weight: bold;
        display: inline-block;
        width: 120px;
        color: #1a2732;
    }
    
    .b-pagination {
        justify-content: center;
    }
    
    ::v-deep .page-link {
        padding: 0.25rem 0.5rem;
        font-size: 0.875rem;
    }
}

/* Mejoras generales */
.action-btn {
    transition: all 0.3s ease;
    border-radius: 6px;
    font-weight: 500;
}

.action-btn:hover {
    transform: translateY(-1px);
    box-shadow: 0 2px 8px rgba(0,0,0,0.15);
}

.spinner-wrap {
    min-height: 120px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.Grafico-wrapper {
    width: 100%;
    height: 100%;
}

/* Estilos para enlaces de ubicación en la tabla */
.ubicacion-link {
    color: #0d6efd !important;
    font-weight: 500;
    cursor: pointer;
    transition: color 0.2s ease;
}

.ubicacion-link:hover {
    color: #0a58ca !important;
    text-decoration: underline !important;
}

/* Ocultar elementos en móvil si es necesario */
@media (max-width: 575.98px) {
    .d-none-mobile {
        display: none !important;
    }
}

/* Mostrar solo en móvil */
@media (min-width: 576px) {
    .d-mobile-only {
        display: none !important;
    }
}
</style>